import { render, staticRenderFns } from "./ControlsGroup.vue?vue&type=template&id=15fb97d2"
import script from "./ControlsGroup.vue?vue&type=script&lang=js"
export * from "./ControlsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports